export default __webpack_public_path__ + "static/media/Live2DSim.ceff0ad4.png";